import "./index.css";
import HomePage from "./Pages/HomePage/HomePage"

const App = () => {
    return (
        <div>
            <HomePage />
        </div>
    );
};
export default App;